import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  AnalyticsInfo,
  IClientInfoFormData,
  ITeamMemberInfoFormData,
  ITeamMemberPermissionInfo,
  ProjectDetails,
  TeamMemberStatus,
} from '../../components/pages/user-management/models';

interface TeamMemberState {
  teamMemberInfo: ITeamMemberInfoFormData;
  clientInfo: IClientInfoFormData;
  selectedUserEmailAddress: string;
  projectList: ProjectDetails[];
  analyticsInfo: AnalyticsInfo;
  teamMemberPermissionInfo: ITeamMemberPermissionInfo;
}

const initialState: TeamMemberState = {
  teamMemberInfo: {
    userId: '',
    firstName: '',
    lastName: '',
    email: '',
    isActive: false,
    isBillable: false,
    isLimitIp: false,
    ipAddressList: [],
    status: TeamMemberStatus.invited,
  },
  clientInfo: {
    role: '',
    client: '',
    permissionGroup: '',
    permissionGroupId: '',
    project: '',
    workspaces: [],
  },
  selectedUserEmailAddress: '',
  projectList: [],
  analyticsInfo: {
    userRole: '',
    numberOfProject: '0',
  },
  teamMemberPermissionInfo: {
    clientPermList: [],
    projPermList: [],
  },
};

const teamMemberSlice = createSlice({
  name: 'teamMember',
  initialState,
  reducers: {
    setTeamMember(state, action: PayloadAction<ITeamMemberInfoFormData>) {
      state.teamMemberInfo = {...action.payload};
      state.selectedUserEmailAddress = action.payload.email;
    },
    editTeamMember(state, action: PayloadAction<ITeamMemberInfoFormData>) {
      state.teamMemberInfo = {...action.payload};
    },
    setClientInfo(state, action: PayloadAction<IClientInfoFormData>) {
      state.clientInfo = {...action.payload};
    },
    setSelectedUserEmailAddress(state, action: PayloadAction<string>) {
      state.selectedUserEmailAddress = action.payload;
    },
    setProjectList(state, action: PayloadAction<ProjectDetails[]>) {
      state.projectList = action.payload;
    },
    setUserId(state, action: PayloadAction<string>) {
      state.teamMemberInfo.userId = action.payload;
    },
    setAnalyticsInfo(state, action: PayloadAction<AnalyticsInfo>) {
      state.analyticsInfo = action.payload;
    },
    setTeamMemberPermissionInfo(
      state,
      action: PayloadAction<ITeamMemberPermissionInfo>
    ) {
      state.teamMemberPermissionInfo = action.payload;
    },
  },
});

export const {
  setTeamMember,
  setClientInfo,
  setSelectedUserEmailAddress,
  setProjectList,
  setUserId,
  editTeamMember,
  setAnalyticsInfo,
  setTeamMemberPermissionInfo,
} = teamMemberSlice.actions;

export default teamMemberSlice.reducer;
